import { delay, distinctUntilChanged, Observable, of, startWith, switchMap } from "rxjs";

export function debounceLoading(delayMs: number = 300) {
    return (source$: Observable<boolean>) =>
        source$.pipe(
            distinctUntilChanged(),
            switchMap(loading => {
                if (loading) {
                    return of(true).pipe(delay(delayMs));
                } else {
                    return of(false);
                }
            }),
            startWith(false)
    );
}
